import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const ScienceLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_13_"
        x1="776.171"
        x2="843.975"
        y1="182.388"
        y2="182.388"
        gradientTransform="rotate(-25.604 810.161 185.217)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="15.41"
        y="20.66"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(-19.82 30.02) rotate(-28.82)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_13_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(13 43) rotate(-28.82)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_12_"
        x1="841.806"
        x2="913.779"
        y1="143.369"
        y2="143.369"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="109.41"
        y="10.45"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(-1.22 4.23) rotate(-1.69)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_12_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(116 18) rotate(-1.69)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_11_"
        x1="915.016"
        x2="976.62"
        y1="122.606"
        y2="122.606"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="204.64"
        y="18.83"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="matrix(1, 0.08, -0.08, 1, 4.65, -18.01)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_11_)"
      />
      <image
        width="52"
        height="52"
        transform="matrix(1, 0.08, -0.08, 1, 214, 24)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_9_"
        x1="831.729"
        x2="903.724"
        y1="236.319"
        y2="236.319"
        gradientTransform="rotate(-4.156 865.785 230.012) scale(1.00003)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="23.89"
        y="105.98"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(-28.84 15.71) rotate(-12.56)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_9_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(26 120) rotate(-12.56)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_10_"
        x1="902.864"
        x2="975.387"
        y1="198.965"
        y2="198.965"
        gradientTransform="rotate(-24.03 941.464 202.186)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="101.87"
        y="91.08"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(9.87 -9.95) rotate(4.38)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_10_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(111 96) rotate(4.38)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_14_"
        x1="972.811"
        x2="1035.764"
        y1="161.261"
        y2="161.261"
        gradientTransform="rotate(17.855 1006.45 166.997)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="178.21"
        y="94.77"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(10.37 -15.77) rotate(4.38)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_14_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(188 99) rotate(4.38)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g className="digital-resources-science" transform="translate(1143, 10)">
      <defs>
        <linearGradient
          id="ec7f9a71-9709-4cb4-8268-1a2ba3bf695b"
          x1="374.65"
          y1="167.91"
          x2="334.37"
          y2="629.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#663d3c" />
          <stop offset="0.01" stopColor="#663d3c" />
          <stop offset="0.32" stopColor="#794545" />
          <stop offset="0.64" stopColor="#834a4a" />
          <stop offset="1" stopColor="#874c4c" />
        </linearGradient>
        <linearGradient
          id="b97a093e-5bb4-42d1-87ac-1230a5e9c76b"
          x1="99.71"
          y1="188.24"
          x2="95.26"
          y2="353.31"
          href="#ec7f9a71-9709-4cb4-8268-1a2ba3bf695b"
        />
        <linearGradient
          id="e939e23a-b251-4155-b673-9d325cb6469e"
          x1="201"
          y1="240.77"
          x2="174.88"
          y2="539.9"
          href="#ec7f9a71-9709-4cb4-8268-1a2ba3bf695b"
        />
        <linearGradient
          id="ff8621fc-6f2b-436b-8ba2-8b6dc9774abe"
          x1="145.51"
          y1="274.8"
          x2="133.22"
          y2="415.49"
          href="#ec7f9a71-9709-4cb4-8268-1a2ba3bf695b"
        />
        <linearGradient
          id="f989be23-3b3b-4e4c-a519-0830cbcf492a"
          x1="325.4"
          y1="284.15"
          x2="313.41"
          y2="421.41"
          href="#ec7f9a71-9709-4cb4-8268-1a2ba3bf695b"
        />
      </defs>
      <g id="f3ae0974-be26-4719-9a4a-493009d3b548" data-name="isl8">
        <g>
          <path
            d="M8,178.6s30.51,55.84,47.6,81.25c5.73,8.52,11.44-7.1,12.07-4.44C68.2,257.67,74.89,274,81,278.9c12.67,10.15,34.92,28.57,50.16,27.94a85.57,85.57,0,0,1,20,16.42l20.24,34.49L322.7,335l9,14,35.66-47.87,17.77-33s44.43-85.36,43.81-88.25S401.81,132,401.81,132L318.37,233.61s15.74,45.06,12,46-111.81-22.19-121.75-29.9-5-14.47-5-14.47-21.12-9.65-38.52-10.62-31.68-28.94-42.86-38.58-29.82-3.86-44.11,3.86-28.57,1.93-27.33-6.76S8,178.6,8,178.6Z"
            fill="#874c4c"
          />
          <path
            d="M332.7,261c6,4,37,11,35,19s-36,69-36,69,30-27,33-38,6-14,6-14l31.65-59Z"
            fill="url(#ec7f9a71-9709-4cb4-8268-1a2ba3bf695b)"
          />
          <path
            d="M77.19,211.6c10.16-5.71,17.14-8.25,24.76,1.91s8.89,79.36,15.88,88.25c4.44,5.08-14,1.27-27.3-17.78S77.19,211.6,77.19,211.6Z"
            fill="url(#b97a093e-5bb4-42d1-87ac-1230a5e9c76b)"
          />
          <path
            d="M170.7,358c-3-20,0-76,0-76s45.34,10.29,52,16C204.61,301.81,170.7,358,170.7,358Z"
            fill="url(#e939e23a-b251-4155-b673-9d325cb6469e)"
          />
          <path
            d="M103.62,232.27c-.35-4.18.12-8.47-1.06-12.52-3.87-13.25-18.39-8.56-31.78-2.68-6.71,2.94-17.83-.91-24.93,1.1s-16.45.19-19-6.27c-.87-2.22-.82-4.65-1.54-6.91-1.49-4.67-5.92-7.88-9.38-11.53-6.73-7.09-10.08-16.33-13.27-25.3C1.22,164.16-.22,160,0,155.82c.64-10.77,11.57-18.15,21.41-23.9,17.83-10.41,2.4-21.45,20.22-31.86,21-12.25,82.14-8.52,106.82-10.7,27.12-2.39,47.8-7.57,75-7,24.65.48,49.83-7.18,73.55-.95,9.31,2.44,59.14,7.84,67.55,12.27,19.22,10.14,37.9,15.54,57.13,25.68,12.21,6.44-15.83,16.85-1.83,17.84,4.56.32,9.36.08,13.43,2,7.4,3.5,9.27,12.71,7.82,20.29s-5.29,14.73-5.89,22.41c-.24,3,0,6.27-1.66,8.91-4.34,7-18.66,5.43-20.6,13.28-.74,3,.91,6.45-.66,9.2-2.5,4.37-12,7-8.41,10.68.86.87,2.21,1.1,3.37,1.59,6.35,2.73,3.94,12.63-2.4,15.37s-13.77.84-20.55-.77-14.65-2.7-20.24,1.21c-3.08,2.16-5.25,5.73-9,6.54-2.27.49-4.63-.17-7-.11-8.48.22-13.09,9.07-15.79,16.52l38.13,8.65c4.91,1.11,7.08,6.93-3.9,10.23s-22.75,3.41-34.3,3.48c-51.13.32-104.25,4.52-155.18.08C147.9,284.19,106.14,262.26,103.62,232.27Z"
            fill="#68c902"
          />
          <path
            d="M107.35,220.44c-11.2-5.09-15.82-1.64-12.86,1.32S121.32,226.79,107.35,220.44Z"
            fill="#68c902"
          />
          <path
            d="M38.36,222.29l.56-1.34c.59,1.87,3.81,1.93,4.47.09.83,1.47,2.49,3.17,3.89,2.21.38-.26.62-.67,1-.95,1.2-.91,2.92.08,3.92,1.21s2,2.55,3.54,2.6a7.35,7.35,0,0,0,.74-5.2A16.78,16.78,0,0,0,60.78,224a14.69,14.69,0,0,0,1-3.87c.91,2.1,4,1.62,6.12.78l8.93-3.51A41.46,41.46,0,0,1,81,226.77c-.84-4.23-1.33-9.46,2.13-12a45.09,45.09,0,0,0,.71,9.06C89.2,218.6,89,210,88.44,202.56a89,89,0,0,0-9.46,3,114.36,114.36,0,0,1-18,3.84l-21,3.32c-2.21.35-6.51.17-7,3.1C32.73,217.59,36.61,222.29,38.36,222.29Z"
            fill="#68c902"
          />
          <ellipse
            cx="267.67"
            cy="267.58"
            rx="30.48"
            ry="7.94"
            fill="#54ba02"
          />
          <path
            d="M267.67,259.64c-14.7,0-27,2.71-29.84,6.32,5.2-2.44,15.19-4.1,26.66-4.1,16.83,0,30.48,3.56,30.48,7.94a2.62,2.62,0,0,1-.64,1.62c2.42-1.14,3.81-2.45,3.81-3.84C298.14,263.2,284.5,259.64,267.67,259.64Z"
            fill="#4fb002"
          />
          <ellipse
            cx="218.57"
            cy="275.83"
            rx="17.47"
            ry="4.55"
            fill="#54ba02"
          />
          <path
            d="M218.57,271.28c-8.43,0-15.46,1.56-17.11,3.62,3-1.4,8.71-2.34,15.29-2.34,9.65,0,17.47,2,17.47,4.55a1.49,1.49,0,0,1-.37.93c1.39-.66,2.19-1.41,2.19-2.21C236,273.32,228.22,271.28,218.57,271.28Z"
            fill="#4fb002"
          />
          <ellipse
            cx="366.29"
            cy="219.11"
            rx="21.16"
            ry="5.51"
            fill="#54ba02"
          />
          <path
            d="M366.29,213.6c-10.21,0-18.72,1.88-20.72,4.39,3.61-1.7,10.54-2.84,18.51-2.84,11.69,0,21.17,2.46,21.17,5.51a1.8,1.8,0,0,1-.45,1.12c1.69-.79,2.65-1.7,2.65-2.67C387.45,216.07,378,213.6,366.29,213.6Z"
            fill="#4fb002"
          />
          <ellipse
            cx="334.28"
            cy="212.92"
            rx="11.17"
            ry="2.91"
            fill="#54ba02"
          />
          <path
            d="M334.28,210c-5.39,0-9.89,1-10.94,2.32,1.9-.9,5.57-1.5,9.77-1.5,6.18,0,11.18,1.3,11.18,2.91a.92.92,0,0,1-.24.59c.89-.41,1.4-.9,1.4-1.41C345.45,211.32,340.45,210,334.28,210Z"
            fill="#4fb002"
          />
          <path
            d="M65.5,239.06s-8.89-.42-10.37,1.06-9.74.42-9.74.42l-1.27-5.08a59.26,59.26,0,0,0-3.59,4.87c-.22.64-1.06,3.39-1.06,3.39l1.9,6.35,1.27-4.87,3.18.84a26.4,26.4,0,0,1,.84,3.39c0,.64,1.7-3.6,1.7-3.6l2.75,1.06,1.06-2.54,2.11,1.48.64,4.45,1.9-6.78L58.3,245l1.27-2.33,1.91-1.06Z"
            fill="#45a102"
          />
          <path
            d="M205.68,306l3.95,2.89,7.92.22,18.37-2s-7,3.56-7.63,3.73-12.21,1-12.21,1l-3,3.33L211.4,312l-1.55-.29L209,316l-1.91-5.16-3,1.83-.42-3.33Z"
            fill="#45a102"
          />
          <path
            d="M217,286.42c5.74,1.39,13-.71,18.89-.38,4.29.25,7.46-.31,11.75-.63,30-2.27,59.74-.82,89.78-3.09,6.33-.48,12.75-.95,19,.2,1.49.28,3.36,1.26,3,2.72-.3,1.08-1.65,1.41-2.76,1.55l-19.16,2.35a7.57,7.57,0,0,1-3.66,6.74,23.94,23.94,0,0,0,.17-6.71c-3.53,1-7.24.87-10.89.77l-2.56-.06-15.49-.41,1.3,2.59a30.92,30.92,0,0,0-21.1-.68,42.1,42.1,0,0,1,9.92,3.83,34.72,34.72,0,0,1-20.42-4.32,6.45,6.45,0,0,1-7.14,1.28,5.84,5.84,0,0,1-8.86-1.08l-.86,11.4a27.09,27.09,0,0,1-4.68-12.7,6.83,6.83,0,0,1-7.42,2,28.39,28.39,0,0,1-18.93-1.1c-3.93-1.63-7.09-4.47-11.32-5.35-6.3-1.31-13.2.53-19.67-.08a138.64,138.64,0,0,1-19-3.62c-8.83-2.12-21.2-6.81-30.23-4.62.3,3.06,2.8,5.83,5.59,7,1.06.46,2.82.29,2.77-.87.62,1.59,1.35,3.31,2.87,4.1s3.91-.19,3.74-1.88c3.77,3.32,9.63,4.94,13.88,2.25a6.29,6.29,0,0,0,8.76,1.8l3.95,8.06a28.13,28.13,0,0,0,4-8.94,3.73,3.73,0,0,0,5.59,1.33c1.68,2.76,5.22,3.93,8.44,3.7s6.24-1.62,9.17-3l1.09,5c1.61-1.41,3.08-3.3,3-5.43a4.27,4.27,0,0,0-.59-1.92"
            fill="#68c902"
          />
          <path
            d="M349.13,257.66a14.73,14.73,0,0,0-4.54-4.85l9.88-1.29-4.1-1.53a49.91,49.91,0,0,0,24.15-2.13,45.16,45.16,0,0,0-11.2-2.9A17,17,0,0,1,376,242.12c3,.54,6.87,1.58,8.54-1l5.79,1.87c.6-.95-.36-2.11-1.27-2.77-7.46-5.42-17.31-6.93-26.4-5.37s-17.49,5.95-25,11.37a12.27,12.27,0,0,0-3.33,3.17c-1.81,2.81-5.06,13.43.68,13.77,3.35.2,2.81-3.47,4.52-4.68C340.17,258,348.52,256.62,349.13,257.66Z"
            fill="#68c902"
          />
          <path
            d="M55,95.6a6.91,6.91,0,0,0,2.84-3.27A6.18,6.18,0,0,0,68.6,86.84l3.06,9.92c5.59-6.9,13.25-14.57,21.88-12.44A7.45,7.45,0,0,0,85.33,91a13,13,0,0,1,9.73.56,4.18,4.18,0,0,0,2.61-2.42c1,2.31,4.89,1.43,5.85-.89s0-4.95-1-7.27a25.77,25.77,0,0,1,9.54,11.51l5.83-3.68C116.61,90,119.85,91,121.37,90s4.72-.91,3.92.73a78.34,78.34,0,0,1,5-16.82,31.93,31.93,0,0,0,2.52,15.35,5.77,5.77,0,0,0,2.48-2.71c-.11,1.17,1.39,1.75,2.56,1.89a45.22,45.22,0,0,0,32.19-8.68L166,87.13a33.73,33.73,0,0,1,20.32-2.53l.18-5.74,10.52,5,2.68-3.46a22.5,22.5,0,0,0,5.07,5.46c-2.27,3.8-7.4,4.5-11.82,4.76q-24.68,1.49-49.4,2.07c-19.61.47-39.41.6-58.75,4.28-9.34,1.77-18.71,7.16-27.82,8.47-8.4,1.21-11.73-7-8.16-14.5A14.5,14.5,0,0,1,55,95.6Z"
            fill="#68c902"
          />
          <path
            d="M212.71,80.68c.88.16,1.68.6,2.55.83,4.93,1.33,8.9-4,11.25-8.51l1.94,2.67a3.32,3.32,0,0,0,2.66-1l7.37,5.22a8.57,8.57,0,0,0,8.25-4.13c.06,3,4.1,4.35,7,3.45s5.21-3.08,8.09-4,6.91.47,6.95,3.48l3.32-1.53c-1,.6.49,1.94,1.63,1.92a9.2,9.2,0,0,0,8.2-5.64l4.89,5.43,3.61-2.41a7.25,7.25,0,0,0,3.17,3.83A18.81,18.81,0,0,1,302,69.93a30.92,30.92,0,0,0-3.18,11.33l3.67-3c2.3,2,1.14,6.11-1.42,7.77s-5.83,1.61-8.88,1.51q-26.67-.86-53.35-.06c-7.75.24-17.34,2.38-24.94,1.22-2.51-.38-4.4.7-5.61-2.28C207.12,83.7,209.63,80.15,212.71,80.68Z"
            fill="#68c902"
          />
          <path
            d="M418.63,113.17l-3.56,1L413.68,112c.22,1.17-1.5,1.91-2.51,1.3a4.24,4.24,0,0,1-1.59-3.07,24.93,24.93,0,0,1,.05-8.7,18.43,18.43,0,0,0-4.33,7.56l-1.11-2.19-1.89.89c-2.17.11-4-2.92-5.94-2-.46.23-.82.67-1.32.8-.75.21-1.48-.34-2.1-.81A20.12,20.12,0,0,0,382,101.71c3.62,6.14,10.28,9.74,16.76,12.71,4.63,2.12,26.82,14,26.17.79-1,1-3.16,1.41-4.24,2.28C420.51,117.28,418.25,113.27,418.63,113.17Z"
            fill="#68c902"
          />
          <path
            d="M128.7,296c-7.4,5.93,11,25,17,31s11,5,11,5,3-14-3-25S133.7,292,128.7,296Z"
            fill="url(#ff8621fc-6f2b-436b-8ba2-8b6dc9774abe)"
          />
          <path
            d="M335.7,315c0,8-7,25-12,24s-11-5-12-12-7-23,9-23S335.7,315,335.7,315Z"
            fill="url(#f989be23-3b3b-4e4c-a519-0830cbcf492a)"
          />
        </g>
      </g>
      <g id="b8218a20-f46f-46da-bea5-4b83a50c33a9" data-name="flag science">
        <g>
          <ellipse cx="70.28" cy="185.96" rx="19.61" ry="11.3" fill="#55a32a" />
          <path
            d="M74.26,190.43c0,3.61-6.61,6.54-14.77,6.54S44.71,194,44.71,190.43c0-.75.06-2.94.06-2.94s8.25-3.6,14.72-3.6,14.74,3.54,14.74,3.54S74.26,189.64,74.26,190.43Z"
            fill="#8abcf8"
          />
          <ellipse cx="59.49" cy="187.69" rx="14.78" ry="6.54" fill="#9ae1f8" />
          <path
            d="M59,186.06c1.22,1.11,12.11-2.61,12.11-2.61s-4.08-1.53-4.81-1.71a43,43,0,0,0-8.52,2.62Z"
            fill="#8aa6f8"
          />
          <path
            d="M59.68,186.75h-2.4V22.64L59.47,0l2.22,22.64v162.1A2,2,0,0,1,59.68,186.75Z"
            fill="#9ae1f8"
          />
          <path
            d="M59.47,0l-1,10.42,1.21,12.4V186.75h0a2,2,0,0,0,2-2V22.64Z"
            fill="#8abcf8"
          />
          <path
            d="M90.39,59.16s7.52,42.67-5,72.49c-6.94,16.5-18,36.25-18,36.25L43.24,141.38,30.07,167.9S18.73,136,26.68,115.63c6.24-16,4.4-61.09,4.4-61.09Z"
            fill="#dd8a03"
          />
          <rect
            x="27.46"
            y="52.67"
            width="69.63"
            height="3.77"
            rx="1.66"
            transform="translate(118.67 115.18) rotate(-174.15)"
            fill="#9ae1f8"
          />
          <path
            d="M90,59.1s7.1,42.12-5.44,71.94c-6.94,16.5-18.19,35.84-18.19,35.84L41.11,140.06l-11,27.84s-11.71-33.15-3.75-53.54c6.24-16,4.39-61.1,4.39-61.1Z"
            fill="#ffa511"
          />
          <path
            d="M86.62,55.15a2.55,2.55,0,0,0,0,3.84c-7.24-.71-17.79-1.78-17.79-1.78s-2.05-2.17.34-3.81C75,53.78,86.62,55.15,86.62,55.15Z"
            fill="#ffa511"
          />
          <path
            d="M52,51.5a2.56,2.56,0,0,0,0,3.85c-7.24-.71-17.79-1.78-17.79-1.78s-2-2.17.34-3.81C40.3,50.14,52,51.5,52,51.5Z"
            fill="#ffa511"
          />
          <path
            d="M57.28,22.64V33.77a4.41,4.41,0,0,0,2.74.59c.43,0,1.25-.23,1.67-.27V22.64L59.47,0Z"
            fill="#cfdff1"
          />
          <path
            d="M27.62,51.23l.05-.44a1.66,1.66,0,0,1,1.82-1.49h.14a1.85,1.85,0,0,0,0,.23l-.05.44A1.67,1.67,0,0,0,31,51.81l65.81,6.74a1.65,1.65,0,0,1-1.78,1.26L29.11,53.05A1.66,1.66,0,0,1,27.62,51.23Z"
            fill="#9ae1f8"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M59.47,0,59,4.87l1.59,16.24L60.81,33A14.66,14.66,0,0,1,59,33a8.6,8.6,0,0,1-1.67-.3v1.05a4.41,4.41,0,0,0,2.74.59c.43,0,1.25-.23,1.67-.27V22.64Z"
            fill="#bad2f1"
          />
          <path
            d="M61.9,33.42c0,.56-1.08,1-2.4,1s-2.4-.45-2.4-1"
            fill="none"
            stroke="#cfdff1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.71,53.26s.75,18.22-.31,35.6c16.12,5.53,43.93,11.5,61,12A185.93,185.93,0,0,0,90,59.1Z"
            fill="#e31c10"
            opacity="0.13"
          />
          <ellipse
            cx="55.84"
            cy="101.19"
            rx="7.78"
            ry="7.34"
            transform="translate(-50.51 146.41) rotate(-84.14)"
            fill="#e33682"
          />
          <ellipse
            cx="56.11"
            cy="101.06"
            rx="27.67"
            ry="9.34"
            transform="translate(-52.69 62.02) rotate(-41.22)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <ellipse
            cx="56.11"
            cy="101.06"
            rx="9.34"
            ry="27.67"
            transform="translate(-49.57 54.23) rotate(-37.06)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <ellipse
            cx="44.8"
            cy="80.09"
            rx="3.68"
            ry="3.48"
            transform="translate(-39.45 116.49) rotate(-84.14)"
            fill="#98eeff"
          />
          <ellipse
            cx="63.19"
            cy="122.31"
            rx="5.84"
            ry="5.51"
            transform="translate(-64.93 172.69) rotate(-84.14)"
            fill="#ffdc05"
          />
        </g>
      </g>
      <g id="b2d5f0dd-98c7-4787-8c5f-4fbad382a4a0" data-name="science">
        <g>
          <path
            d="M192.45,254.13a.86.86,0,0,1-.51-.22.66.66,0,0,1-.23-.36,2.48,2.48,0,0,1-.05-.45v-.41c0-.29,0-.58.05-.88s.07-.59.11-.86a.71.71,0,0,1,.18-.38.49.49,0,0,1,.38-.14,1.6,1.6,0,0,1,.33,0l.39.09.77.09a9.66,9.66,0,0,0,1.19.06,12.22,12.22,0,0,0,1.35-.08,7.32,7.32,0,0,0,1.2-.23,2.7,2.7,0,0,0,.85-.42.76.76,0,0,0,.32-.63c0-.2-.22-.35-.67-.47s-1-.23-1.68-.34-1.4-.26-2.19-.43a9.66,9.66,0,0,1-2.18-.76,5.06,5.06,0,0,1-1.68-1.3,3.13,3.13,0,0,1-.68-2.09,3.57,3.57,0,0,1,.76-2.27,5.68,5.68,0,0,1,2-1.57,10.6,10.6,0,0,1,2.77-.91,17.19,17.19,0,0,1,3.13-.29l.84,0,.84.06.11-.52a1,1,0,0,1,.2-.32.56.56,0,0,1,.43-.17,9.11,9.11,0,0,1,2.42.3.91.91,0,0,1,.53.35.79.79,0,0,1,.12.38q0,.78-.09,1.41c0,.42-.07.82-.11,1.18s-.11.72-.17,1.07-.12.69-.18,1.05a.92.92,0,0,1-.25.49.84.84,0,0,1-.61.2c-.5,0-.91,0-1.23,0a7.21,7.21,0,0,1-1-.18.52.52,0,0,1-.4-.28.92.92,0,0,1-.14-.47c0-.17,0-.34,0-.51s0-.35,0-.52l-.9-.09-.85,0a9.65,9.65,0,0,0-1.37.09,6.81,6.81,0,0,0-1.1.23,2.17,2.17,0,0,0-.73.39.69.69,0,0,0-.27.52c0,.28.22.5.64.63a13.16,13.16,0,0,0,1.6.38c.63.11,1.33.25,2.08.42a8.75,8.75,0,0,1,2.09.73,4.7,4.7,0,0,1,1.59,1.31,3.45,3.45,0,0,1,.64,2.18,4,4,0,0,1-.61,2.19,5.22,5.22,0,0,1-1.65,1.62,8.21,8.21,0,0,1-2.48,1,13.23,13.23,0,0,1-3.11.34A18.82,18.82,0,0,1,192.45,254.13Z"
            fill="#fff"
          />
          <path
            d="M211.75,243.48a8.74,8.74,0,0,1,1.12.07,4.7,4.7,0,0,1,1.18.28,1.88,1.88,0,0,1,.77.45,1.54,1.54,0,0,1,.31.86c0,.23.05.45.07.65s0,.42,0,.62a8.2,8.2,0,0,1-.14,1.5,1.16,1.16,0,0,1-.27.62,1,1,0,0,1-.66.16,7.75,7.75,0,0,1-1.26-.09,1.19,1.19,0,0,1-1-1c0-.2-.05-.41-.07-.63s0-.44,0-.66a4.35,4.35,0,0,0-1.2.26,3.38,3.38,0,0,0-1,.55,2.46,2.46,0,0,0-.66.78,2.08,2.08,0,0,0-.25,1,2.65,2.65,0,0,0,.19,1,2.18,2.18,0,0,0,.54.8,2.4,2.4,0,0,0,.85.55,2.87,2.87,0,0,0,1.12.21,4.13,4.13,0,0,0,.67-.07,5.65,5.65,0,0,0,.71-.17c.23-.07.45-.15.65-.23a4.31,4.31,0,0,0,.51-.22l.43-.18a.83.83,0,0,1,.32-.08c.2,0,.38.14.56.41l.27.49a5.36,5.36,0,0,1,.26.54,3.79,3.79,0,0,1,.12.36,1,1,0,0,1,0,.29.87.87,0,0,1-.37.62,4.15,4.15,0,0,1-.84.51,7,7,0,0,1-1.07.39,7.76,7.76,0,0,1-1.2.27,7.17,7.17,0,0,1-1.22.1,9.7,9.7,0,0,1-2.52-.29,6.82,6.82,0,0,1-1.8-.75,4.16,4.16,0,0,1-1.17-1.06,5.17,5.17,0,0,1-.69-1.18,4.72,4.72,0,0,1-.32-1.13,5.77,5.77,0,0,1-.09-.92,4.29,4.29,0,0,1,.61-2.24,6.18,6.18,0,0,1,1.6-1.79,7.86,7.86,0,0,1,2.29-1.17A8.4,8.4,0,0,1,211.75,243.48Z"
            fill="#fff"
          />
          <path
            d="M219.6,238.6a5.74,5.74,0,0,1,1.1.09,1.72,1.72,0,0,1,.75.33,1.37,1.37,0,0,1,.41.68,4,4,0,0,1,.13,1.14,2.64,2.64,0,0,1-.1.76,1.4,1.4,0,0,1-.36.61,1.59,1.59,0,0,1-.74.4,4,4,0,0,1-1.19.14,5.67,5.67,0,0,1-1.1-.09,1.53,1.53,0,0,1-.71-.35,1.37,1.37,0,0,1-.38-.64,3.68,3.68,0,0,1-.12-1,2.06,2.06,0,0,1,.52-1.53A2.54,2.54,0,0,1,219.6,238.6Zm-1.91,6.5a2.7,2.7,0,0,1,.14-.83.63.63,0,0,1,.58-.4,5.48,5.48,0,0,1,.89-.12l1,0h.4l.37,0c.24,0,.38.08.43.18a1.72,1.72,0,0,1,.08.68c0,1.54,0,3,0,4.31s-.12,2.73-.22,4.16c0,.22,0,.4-.06.55a.75.75,0,0,1-.17.37.7.7,0,0,1-.36.2,2.31,2.31,0,0,1-.67.07,10.75,10.75,0,0,1-1.28-.07,1.27,1.27,0,0,1-.92-.33,1.72,1.72,0,0,1-.25-.81c0-.51-.05-1-.07-1.54s0-1,0-1.51c0-.82,0-1.63.05-2.43S217.63,245.94,217.69,245.1Z"
            fill="#fff"
          />
          <path
            d="M234.38,249.16a13.58,13.58,0,0,1-1.42.37c-.56.11-1.15.21-1.78.3s-1.28.16-2,.22-1.32.11-1.94.14a3.35,3.35,0,0,0,1.2.79,4.23,4.23,0,0,0,1.55.29,8.2,8.2,0,0,0,1.42-.16,7.13,7.13,0,0,0,1.48-.47,1.87,1.87,0,0,1,.49-.15.32.32,0,0,1,.28.12,1.46,1.46,0,0,1,.19.36,3.68,3.68,0,0,1,.15.47c0,.16.07.31.11.47a.7.7,0,0,1,0,.23v.2a.92.92,0,0,1-.37.73,5,5,0,0,1-2,1,10,10,0,0,1-2.85.38,6.34,6.34,0,0,1-2.2-.39,5.57,5.57,0,0,1-1.86-1.09,5.4,5.4,0,0,1-1.29-1.7,4.89,4.89,0,0,1-.49-2.22,5.06,5.06,0,0,1,.5-2.26A5.68,5.68,0,0,1,225,245a6,6,0,0,1,1.94-1.15,6.62,6.62,0,0,1,2.29-.41,6.12,6.12,0,0,1,2.71.54,5.6,5.6,0,0,1,1.78,1.31,5.09,5.09,0,0,1,.95,1.61,4.63,4.63,0,0,1,.29,1.42,1,1,0,0,1-.12.48A.82.82,0,0,1,234.38,249.16Zm-5.08-2.73a2.75,2.75,0,0,0-1.51.45,2.32,2.32,0,0,0-.95,1.14c.69,0,1.43-.07,2.21-.13a16.23,16.23,0,0,0,2.14-.3,1.64,1.64,0,0,0-.8-.89A2.47,2.47,0,0,0,229.3,246.43Z"
            fill="#fff"
          />
          <path
            d="M236.15,244.92a4.26,4.26,0,0,1,.1-.82.64.64,0,0,1,.55-.44,4.86,4.86,0,0,1,.65-.11l.77-.08.79-.05.68,0a.56.56,0,0,1,.46.15.63.63,0,0,1,.12.41c0,.08,0,.17,0,.27s0,.19,0,.31a6.45,6.45,0,0,1,1.83-.84,7,7,0,0,1,2-.28,6.7,6.7,0,0,1,1.11.1,3.53,3.53,0,0,1,1.17.4,2.61,2.61,0,0,1,.94.93,3,3,0,0,1,.39,1.64c0,.39,0,.84,0,1.36s-.05,1.07-.09,1.67-.09,1.21-.16,1.85-.15,1.29-.25,1.92a1.81,1.81,0,0,1-.22.68c-.11.2-.38.31-.78.31-.23,0-.54,0-.92-.06a8.75,8.75,0,0,1-1.08-.16.85.85,0,0,1-.75-.94c0-.16,0-.36,0-.59s0-.56.09-1,.07-.9.1-1.51,0-1.34,0-2.23a1.38,1.38,0,0,0-.22-.83.76.76,0,0,0-.66-.31,4.38,4.38,0,0,0-1.24.2,5.7,5.7,0,0,0-1.32.64c0,.93,0,1.85.08,2.75s.13,1.8.22,2.71l0,.23a1.7,1.7,0,0,1,0,.22.68.68,0,0,1-.24.56,1.89,1.89,0,0,1-1,.24l-.36,0h-.8l-.35,0a1.35,1.35,0,0,1-.95-.31,1.57,1.57,0,0,1-.29-.77c-.12-1.09-.22-2.2-.3-3.32s-.11-2.25-.11-3.37v-.77C236.13,245.44,236.13,245.18,236.15,244.92Z"
            fill="#fff"
          />
          <path
            d="M255.89,243.48a8.74,8.74,0,0,1,1.12.07,4.7,4.7,0,0,1,1.18.28,1.88,1.88,0,0,1,.77.45,1.54,1.54,0,0,1,.31.86c0,.23.05.45.07.65s0,.42,0,.62a8.2,8.2,0,0,1-.14,1.5,1.16,1.16,0,0,1-.27.62,1.06,1.06,0,0,1-.66.16,7.75,7.75,0,0,1-1.26-.09,1.19,1.19,0,0,1-1-1c0-.2,0-.41-.07-.63s0-.44,0-.66a4.35,4.35,0,0,0-1.2.26,3.38,3.38,0,0,0-1,.55,2.46,2.46,0,0,0-.66.78,2.08,2.08,0,0,0-.25,1,2.65,2.65,0,0,0,.19,1,2.28,2.28,0,0,0,.53.8,2.54,2.54,0,0,0,.86.55,2.83,2.83,0,0,0,1.12.21,4.24,4.24,0,0,0,.67-.07,5.65,5.65,0,0,0,.71-.17c.23-.07.45-.15.65-.23a4.31,4.31,0,0,0,.51-.22l.43-.18a.83.83,0,0,1,.32-.08c.2,0,.38.14.56.41l.27.49a5.36,5.36,0,0,1,.26.54,3.79,3.79,0,0,1,.12.36,1,1,0,0,1,0,.29.87.87,0,0,1-.37.62,4.15,4.15,0,0,1-.84.51,7,7,0,0,1-1.07.39,8,8,0,0,1-1.2.27,7.17,7.17,0,0,1-1.22.1,9.7,9.7,0,0,1-2.52-.29,6.82,6.82,0,0,1-1.8-.75,4.16,4.16,0,0,1-1.17-1.06,5.17,5.17,0,0,1-.69-1.18,5.28,5.28,0,0,1-.33-1.13,7,7,0,0,1-.08-.92,4.29,4.29,0,0,1,.61-2.24,6.18,6.18,0,0,1,1.6-1.79,7.86,7.86,0,0,1,2.29-1.17A8.4,8.4,0,0,1,255.89,243.48Z"
            fill="#fff"
          />
          <path
            d="M272.21,249.16a13.58,13.58,0,0,1-1.42.37c-.56.11-1.15.21-1.78.3s-1.28.16-2,.22-1.32.11-1.94.14a3.35,3.35,0,0,0,1.2.79,4.23,4.23,0,0,0,1.55.29,8.2,8.2,0,0,0,1.42-.16,7.22,7.22,0,0,0,1.49-.47,1.74,1.74,0,0,1,.48-.15.32.32,0,0,1,.28.12,1.19,1.19,0,0,1,.19.36,3.68,3.68,0,0,1,.15.47c0,.16.07.31.11.47a.7.7,0,0,1,0,.23v.2a.92.92,0,0,1-.37.73,5,5,0,0,1-2,1,10,10,0,0,1-2.85.38,6.34,6.34,0,0,1-2.2-.39,5.67,5.67,0,0,1-1.86-1.09,5.4,5.4,0,0,1-1.29-1.7,4.89,4.89,0,0,1-.49-2.22,5.19,5.19,0,0,1,.5-2.26,5.68,5.68,0,0,1,1.34-1.77,6.08,6.08,0,0,1,1.94-1.15,6.62,6.62,0,0,1,2.29-.41,6.16,6.16,0,0,1,2.72.54,5.67,5.67,0,0,1,1.77,1.31,5.09,5.09,0,0,1,.95,1.61,4.63,4.63,0,0,1,.29,1.42,1,1,0,0,1-.12.48A.82.82,0,0,1,272.21,249.16Zm-5.08-2.73a2.75,2.75,0,0,0-1.51.45,2.26,2.26,0,0,0-.95,1.14c.7,0,1.43-.07,2.21-.13a16.23,16.23,0,0,0,2.14-.3,1.64,1.64,0,0,0-.8-.89A2.47,2.47,0,0,0,267.13,246.43Z"
            fill="#fff"
          />
        </g>
      </g>
      <g id="b544634d-33f8-49f4-8536-738cbab2137e" data-name="decor8">
        <g>
          <ellipse cx="360.13" cy="197" rx="12.58" ry="5.51" fill="#55a32a" />
          <path
            d="M351.4,144.34c-.19,3.69.39,12.23-2.13,17.47s-6.4,7.76-3.69,14.74,2.53,16.49,1.94,18.62-.77,2.91-.77,2.91a2.59,2.59,0,0,0,2.71,1.07c1.94-.29,3-2.91,3.11-4.36s1.06-8.44-.29-15.33a60.31,60.31,0,0,1-1.56-13.1c-.09-4.26,1.85-6.79,2.43-10s1.07-11.83,1.07-11.83,6.5.77,7.27-.1c.78-1.94.49-8.53-7.76-8.15s-10,6-9.6,7.57S351.4,144.34,351.4,144.34Z"
            fill="#e53666"
          />
          <path
            d="M354.22,144.54s6.5.77,7.27-.1c.78-1.94.49-8.53-7.76-8.15s-10,6-9.6,7.57,7.27.48,7.27.48a1.15,1.15,0,0,1,0,.19,10.13,10.13,0,0,1,1.37.11l1.44.19C354.21,144.65,354.22,144.54,354.22,144.54Z"
            fill="#e53666"
          />
          <path
            d="M351.4,144.34c.49-.29,2.82.2,2.82.2s-.59,10.77-1.17,12.51C352.18,145.9,351.4,144.34,351.4,144.34Z"
            fill="#bb3666"
          />
          <path
            d="M350.24,202.35c0,1.94,1.94,2.82,4.17,3.11s6-.29,6.21-1.75,0-26.68-.58-27.94c1.74-.38,6.11-1.84,5.82-4.85s-2.14-7.17-8.25-7.76-10.47,2.43-9.89,6.41,6.21,6.3,6.21,6.3a60.07,60.07,0,0,1,.87,10C354.9,192.07,350.24,202.35,350.24,202.35Z"
            fill="#a77de8"
          />
          <path
            d="M352.28,136.29c-1.82.31-4.85,1.36-5.73,2.82s3.2,2.71,6.31,2.42,7.27.68,7.56-1.16-.38-2.91-2.42-3.59A11.83,11.83,0,0,0,352.28,136.29Z"
            fill="#e5679f"
          />
          <ellipse cx="349.08" cy="141.18" rx="1.94" ry="0.97" fill="#e5d7b1" />
          <ellipse cx="351.21" cy="139.59" rx="0.93" ry="0.46" fill="#e5d7b1" />
          <ellipse cx="348.11" cy="139.3" rx="1.26" ry="0.63" fill="#e5d7b1" />
          <ellipse cx="356.96" cy="141.86" rx="1.77" ry="0.89" fill="#e5d7b1" />
          <ellipse cx="359.17" cy="140.29" rx="0.77" ry="0.39" fill="#e5d7b1" />
          <ellipse cx="354.05" cy="137.9" rx="1.65" ry="0.82" fill="#e5d7b1" />
          <path
            d="M354.41,205.46c2.23.29,6-.29,6.21-1.75s0-25-.53-27.72c-2.28,0-5.26-.29-6.9-.47.45.23.74.35.74.35a60.07,60.07,0,0,1,.87,10c.1,6.21-4.56,16.49-4.56,16.49C350.24,204.29,352.18,205.17,354.41,205.46Z"
            fill="#8a6ce8"
          />
          <path
            d="M360.08,175.92a1.55,1.55,0,0,0,0-.15c1.74-.38,6.11-1.84,5.82-4.85a8.9,8.9,0,0,0-1.58-4.32c-.17,5.68-7.44,8.2-15.11,5.91a13.52,13.52,0,0,0,4,3l.77.36S357,176.05,360.08,175.92Z"
            fill="#7b5dce"
          />
          <path
            d="M353.93,175.87s3.2,3.06,4.89,2.52,1.22-2.62,1.22-2.62S354.65,176,353.93,175.87Z"
            fill="#5641ce"
          />
          <ellipse cx="352.83" cy="169.31" rx="3.3" ry="1.42" fill="#e59be8" />
          <ellipse cx="355.09" cy="166.01" rx="1.47" ry="0.63" fill="#e59be8" />
          <ellipse cx="358.65" cy="169.31" rx="1.47" ry="0.63" fill="#e59be8" />
          <path
            d="M369.43,224.62h-21c-.52-.65-1-1.33-1.57-2l.76-1c0-.48-.09-.64-.13-.33,0-.38-.09-3.12,0-4.91s.09-3,.07-3.53a11.27,11.27,0,0,1,.1,1.81c0-1.31.05-2.34.1-3s.11-2.1.07-3.07a75.39,75.39,0,0,1,.15,7.84,12.45,12.45,0,0,1,.11-1.52v.17c.11-2.87.2-4.82.17-5.86a39.62,39.62,0,0,1,.19,4.92c.06-3.07.18-5.34.31-6.57a62.94,62.94,0,0,0,.23-7c.12,0,.3,4.63.3,11.38a5.89,5.89,0,0,1,.13-.87,18.64,18.64,0,0,0,.25-3.8c.06.36.11,2.84.08,6.11.08-.75.17-1.3.24-2.14a79.29,79.29,0,0,0,.34-8.22c0-.84.09-1.06.12-.51,0,.84.08,1.75.1,2.71a24,24,0,0,1,.19,3.66c0-2.67.11-4.77.2-6s.23-4.27.14-6.23c.14-.33.44,6.34.31,15.95a23.64,23.64,0,0,1,.24-3.09v.35c.21-5.84.39-9.83.33-12a77.84,77.84,0,0,1,.39,10c.13-6.25.37-10.87.62-13.38a124.48,124.48,0,0,0,.48-14.25c.24,0,.62,9.43.61,23.17a11.79,11.79,0,0,1,.27-1.76,38.32,38.32,0,0,0,.51-7.74c.12.72.23,5.78.16,12.44.17-1.52.34-2.64.49-4.35a164.66,164.66,0,0,0,.69-16.74c0-1.72.17-2.17.24-1,.3,5.6.37,12.59.14,20.64-.1,3.82-.24,7-.39,9.68l.19,0a.28.28,0,0,0,0-.09c.11-1.08.23-1.81.33-3a101.18,101.18,0,0,0,.43-10.52c0-1.07.12-1.36.15-.65.2,3.52.24,7.91.1,13,0,.37,0,.71,0,1.07.22,0,.43-.06.65-.08,0-.31,0-.61,0-.89.05-2.37.12-4,.09-4.64a15.48,15.48,0,0,1,.13,2.38c0-1.73.07-3.08.13-3.9s.15-2.77.09-4a97.68,97.68,0,0,1,.2,10.32,17.9,17.9,0,0,1,.15-2v.23c.14-3.78.25-6.36.21-7.73a50.64,50.64,0,0,1,.26,6.48c.08-4,.23-7,.4-8.65a81.76,81.76,0,0,0,.31-9.22c.15,0,.4,6.1.39,15a7.73,7.73,0,0,1,.18-1.14,24.3,24.3,0,0,0,.33-5c.08.47.15,3.74.1,8.05.11-1,.22-1.71.32-2.82a104.27,104.27,0,0,0,.44-10.83c0-1.1.12-1.39.16-.67.2,3.63.24,8.15.09,13.35q-.09,3.57-.24,6.07l.13,0c.07-.67.14-1.13.2-1.86a66.35,66.35,0,0,0,.28-6.81c0-.69.07-.88.1-.42.12,2.28.15,5.12.06,8.39q0,.47,0,.9c3.29,1.22,5.82,4.13,8.52,7.78C370.46,223.29,369.94,224,369.43,224.62Zm-19-7c0-.44,0-.89,0-1.34,0,.82-.08,1.55-.12,2.19l.09-.09C350.35,218.13,350.37,217.87,350.39,217.64Z"
            fill="#68c902"
          />
        </g>
        <path
          d="M257.6,320.36c3.89,6.74,9.59,14.46,17.32,13.51-3.18,2.35-3.1,7.45-.81,10.67s6.11,5,9.82,6.32c-1.16,6.57,5.18,12.17,11.52,14.29a33.65,33.65,0,0,0,11.31,1.71,4.07,4.07,0,0,0,2.66-.74,4.28,4.28,0,0,0,1-2.95l1.92-21.31c4.95,3.88,13.47,1.13,15.22-4.91.51-1.75.54-3.7,1.52-5.24s2.58-2.31,4.05-3.25a24.91,24.91,0,0,0,11.29-21.23,17.07,17.07,0,0,0-6.4-32.58c-1.78-.07-4.09.68-4.06,2.46A26.47,26.47,0,0,0,317.5,270c-2.73-.15-6.42,1.25-5.87,3.93-1.09-5.32-25.09,11.79-26.62,12.9-7.05-6.29-24.63-6.93-30.49,1.77-4,5.87.59,8.68,1,14C256,309.2,253.4,313.06,257.6,320.36Z"
          fill="#68c902"
        />
        <g>
          <path
            d="M287.63,295.25c-2.4,2.76-7.2,5-9.21,3.22s-.47-6.81,1.93-9.57,4.76-2.17,6.77-.42S290,292.49,287.63,295.25Z"
            fill="#e4f6fb"
          />
          <path
            d="M287,306.24c-3.63-.48-8.12-3.27-7.77-5.91s5.42-4.15,9.05-3.66,4.43,2.77,4.08,5.41S290.59,306.73,287,306.24Z"
            fill="#e4f6fb"
          />
          <path
            d="M276.78,310.18c-1.31-3.42-1-8.7,1.47-9.65s6.24,2.77,7.55,6.19-.31,5.22-2.81,6.18S278.09,313.59,276.78,310.18Z"
            fill="#e4f6fb"
          />
          <path
            d="M269.68,299.49c3.25-1.69,8.52-2,9.75.38s-2.06,6.51-5.31,8.19-5.22.28-6.45-2.09S266.43,301.17,269.68,299.49Z"
            fill="#e4f6fb"
          />
          <path
            d="M276.15,290.18c3,2.11,5.68,6.65,4.15,8.83s-6.73,1.17-9.72-.93-2.65-4.51-1.11-6.7S273.16,288.07,276.15,290.18Z"
            fill="#e4f6fb"
          />
          <circle cx="278.98" cy="299.29" r="3.87" fill="#feaf26" />
        </g>
        <g>
          <path
            d="M326.61,317.12c-1.49,1.71-4.47,3.09-5.72,2s-.29-4.23,1.2-5.94,3-1.35,4.2-.26S328.1,315.41,326.61,317.12Z"
            fill="#e4f6fb"
          />
          <path
            d="M326.2,324c-2.26-.3-5.05-2-4.83-3.67s3.37-2.58,5.62-2.28,2.76,1.72,2.54,3.37S328.45,324.25,326.2,324Z"
            fill="#e4f6fb"
          />
          <path
            d="M319.87,326.39c-.81-2.12-.63-5.4.92-6s3.87,1.72,4.68,3.84-.19,3.25-1.74,3.84S320.68,328.51,319.87,326.39Z"
            fill="#e4f6fb"
          />
          <path
            d="M315.46,319.75c2-1,5.3-1.23,6.06.24s-1.28,4-3.3,5.09-3.24.17-4-1.3S313.45,320.8,315.46,319.75Z"
            fill="#e4f6fb"
          />
          <path
            d="M319.48,314c1.85,1.31,3.53,4.13,2.58,5.49s-4.18.73-6-.58-1.64-2.8-.69-4.16S317.62,312.67,319.48,314Z"
            fill="#e4f6fb"
          />
          <circle cx="321.23" cy="319.63" r="2.4" fill="#feaf26" />
        </g>
        <g>
          <path
            d="M345.63,279.25c-2.4,2.76-7.2,5-9.21,3.22s-.47-6.81,1.93-9.57,4.76-2.17,6.77-.42S348,276.49,345.63,279.25Z"
            fill="#e4f6fb"
          />
          <path
            d="M345,290.24c-3.63-.48-8.12-3.27-7.77-5.91s5.42-4.15,9.05-3.66,4.43,2.77,4.08,5.41S348.59,290.73,345,290.24Z"
            fill="#e4f6fb"
          />
          <path
            d="M334.78,294.18c-1.31-3.42-1-8.7,1.47-9.65s6.24,2.77,7.55,6.19-.31,5.22-2.81,6.18S336.09,297.59,334.78,294.18Z"
            fill="#e4f6fb"
          />
          <path
            d="M327.68,283.49c3.25-1.69,8.52-2,9.75.38s-2.06,6.51-5.31,8.19-5.22.28-6.45-2.09S324.43,285.17,327.68,283.49Z"
            fill="#e4f6fb"
          />
          <path
            d="M334.15,274.18c3,2.11,5.68,6.65,4.15,8.83s-6.73,1.17-9.72-.93-2.65-4.51-1.11-6.7S331.16,272.07,334.15,274.18Z"
            fill="#e4f6fb"
          />
          <circle cx="336.98" cy="283.29" r="3.87" fill="#feaf26" />
        </g>
        <g>
          <path
            d="M287.69,327.07c-1.52,1.74-4.55,3.14-5.81,2s-.3-4.3,1.21-6,3-1.37,4.28-.26S289.21,325.33,287.69,327.07Z"
            fill="#e4f6fb"
          />
          <path
            d="M287.27,334c-2.29-.31-5.12-2.06-4.9-3.73s3.42-2.62,5.71-2.32,2.8,1.76,2.58,3.43S289.56,334.31,287.27,334Z"
            fill="#e4f6fb"
          />
          <path
            d="M280.84,336.49c-.83-2.15-.64-5.48.93-6.09s3.94,1.75,4.76,3.91-.19,3.3-1.77,3.9S281.67,338.65,280.84,336.49Z"
            fill="#e4f6fb"
          />
          <path
            d="M276.36,329.74c2.05-1.06,5.38-1.25,6.16.25s-1.3,4.11-3.35,5.17-3.3.17-4.08-1.32S274.31,330.81,276.36,329.74Z"
            fill="#e4f6fb"
          />
          <path
            d="M280.44,323.87c1.89,1.33,3.59,4.2,2.62,5.58s-4.24.74-6.13-.59-1.67-2.85-.7-4.23S278.55,322.54,280.44,323.87Z"
            fill="#e4f6fb"
          />
          <circle cx="282.23" cy="329.62" r="2.44" fill="#feaf26" />
        </g>
        <path
          d="M93.79,160a10.28,10.28,0,0,1-.13-3.71l1.38,2a4,4,0,0,1,1.56-1.69,9,9,0,0,0,2.32,2.56l1.91-1.54a1.8,1.8,0,0,0,2.31,1.31,5.27,5.27,0,0,0,2.37-1.8l.9,2a6.5,6.5,0,0,0,2.23-1.37,1.91,1.91,0,0,0,.67,1.68A36.13,36.13,0,0,1,120.86,142a51.38,51.38,0,0,0-11.24,23.42,22.65,22.65,0,0,1,7-7.16,1.37,1.37,0,0,0,.07,2,101.17,101.17,0,0,1-7,12,34.58,34.58,0,0,0-3.54-10l-1.61,2.38a3.82,3.82,0,0,1-1.83-1.62,3.43,3.43,0,0,0-1.87-1.54c-.82-.17-1.81.59-1.52,1.36-1.35-1.21-2.67-2.52-4.11-3.59-.19,2.14.42,4.76-.32,6.75-3.28-2.72-3.88-9.87-5.83-13.58C90.64,154.92,92.21,157.48,93.79,160Z"
          fill="#55a32a"
        />
        <path
          d="M305.79,231a10.28,10.28,0,0,1-.13-3.71l1.38,2a4,4,0,0,1,1.56-1.69,9,9,0,0,0,2.32,2.56l1.91-1.54a1.8,1.8,0,0,0,2.31,1.31,5.27,5.27,0,0,0,2.37-1.8l.9,2a6.5,6.5,0,0,0,2.23-1.37,1.91,1.91,0,0,0,.67,1.68A36.13,36.13,0,0,1,332.86,213a51.38,51.38,0,0,0-11.24,23.42,22.65,22.65,0,0,1,7-7.16,1.37,1.37,0,0,0,.07,2,101.17,101.17,0,0,1-7,12,34.58,34.58,0,0,0-3.54-10l-1.61,2.38a3.82,3.82,0,0,1-1.83-1.62,3.43,3.43,0,0,0-1.87-1.54c-.82-.17-1.81.59-1.52,1.36-1.35-1.21-2.67-2.52-4.11-3.59-.19,2.14.42,4.76-.32,6.75-3.28-2.72-3.88-9.87-5.83-13.58C302.64,225.92,304.21,228.48,305.79,231Z"
          fill="#55a32a"
        />
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(90, 40)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default ScienceLink;
